export default {
  // stamp: `/stamp/:keyword`,
  shortUrlRedirect: '/:id',
  qrcode: `/qr-code/:id`,
  digitalMenus: '/digital-menus/:outletCode/:tableNo',
  portalTo: '/pt/:thirdType/:assetType/:seoKeyword',
};
